import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import strings from "../Globalization/index";
import UserSyncTable from '../AppGrid/UserSyncTable';
import { useBreadcrumbs } from '../contexts/Breadcrumbs';
import connectionService from '../services/Connection';
import consts from '../consts';
import catAdminUtil from '../util/catAdminUtils';

const UserSync = () => {
	const [, setBreadcrumbs] = useBreadcrumbs();
	const navigate = useNavigate();
	useEffect(() => {
		setBreadcrumbs({ docTitle: strings.UserSync, breadcrumbs: [{ text: strings.UserSync }] });

	}, []);

	return (
		<Grid container>
			<Grid size={12}>
				<UserSyncTable onSubmit={(values, { activeRecord, ...parms }) => catAdminUtil.handleOnSubmit({
					values,
					activeRecord,
					maxCount: consts.maxUserCount,
					message: strings.UserCountWarning,
					apiUrl: connectionService.UserSync,
					navigate,
					navigateUrl: "/usersync",
					...parms
				})} />
			</Grid>
		</Grid>
	);
}

export default UserSync;